import { Pipe, PipeTransform } from '@angular/core';

import { campanhaStatuses } from '../campanha-status';

@Pipe({
    name: 'campanhaStatus'
})
export class CampanhaStatusPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = campanhaStatuses.findIndex(status => status.id === value);
        if (index > -1) {
            return campanhaStatuses[index].nome;
        }
        return '';
    }
}
